/**
 * A unified diff, coloured by line.
 *
 * The diff comes from the server (Python's difflib), so the browser only has
 * to render it. Keeping the diffing server-side means the thing the user
 * approves is the same text the server will store.
 */
export default function DiffView({ diff }: { diff: string }) {
  if (!diff.trim()) {
    return <p className="text-sm text-gray-500">No changes.</p>;
  }

  const lines = diff.split("\n");

  return (
    <pre className="max-h-[28rem] overflow-auto rounded-md border border-gray-200 bg-surface text-xs leading-relaxed">
      <code className="block">
        {lines.map((line, index) => (
          <span key={index} className={`block px-3 ${toneFor(line)}`}>
            {line || " "}
          </span>
        ))}
      </code>
    </pre>
  );
}

function toneFor(line: string): string {
  if (line.startsWith("+++") || line.startsWith("---")) return "text-gray-400";
  if (line.startsWith("@@")) return "bg-gray-50 text-gray-500";
  if (line.startsWith("+")) return "bg-accent-50 text-accent-700";
  if (line.startsWith("-")) return "bg-red-50 text-red-700";
  return "text-gray-700";
}
